import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Space,
  message,
  Col,
  Modal,
  Row,
  Card,
} from "antd";
import InputSelect from "./InputSelect";
import InputText from "./InputText";
import TableComponent from "components/TableComponent";

const getItemsNames = (data) => {
  if (!data) {
    return [];
  }
  // Map through the Table6 array to extract item names and IDs
  return data.map((item) => ({
    label: item.ItemName, // Use ItemName for the label
    value: item.ItemName, // Use ItemId for the value
  }));
};

const transformOptions = (data) => {
  return data?.map((item) => {
    return {
      label: item?.TransactionNo,
      value: item?.Id,
    };
  });
};


const PurchseOrder = ({
  dataSet,
  drawerTableData,
  setDrawerTableData,
  title,
}) => {
  const [form] = Form.useForm();
  const itemsOptions = getItemsNames(dataSet?.Table6);

  const handleFinish = async (values) => {

    const { Rate, ItemName, Quantity } = values;
    console.log("checking rate and quantity ", Rate, Quantity)
    // Validate Quantity
    if (!Quantity || Quantity <= 0) {
      message.error("Quantity must be a positive number.");
      return;
    }
    // Validate Rate
    if (!Rate || Rate <= 0) {
      message.error("Rate must be a positive number.");
      return;
    }
    // Find the item based on ItemCode or ItemName
    let item = null;
    if (ItemName) {
      item = dataSet.Table6.find((record) => record.ItemName === ItemName);
    }
    if (!item) {
      message.error("Item not found.");
      return;
    }
    // Create new item with quantity and rate
    const newItem = {
      ...item,
      Quantity: parseFloat(Quantity),
      Rate: parseFloat(Rate), // Include Rate here
    };
    // Check if the item already exists in the drawerTableData
    const itemExists = drawerTableData.some(
      (existingItem) =>
        existingItem.ItemCode === newItem.ItemCode ||
        existingItem.ItemName === newItem.ItemName
    );
    if (itemExists) {
      message.error("Item already exists in the list.");
      return;
    }
    // Update state with new item
    setDrawerTableData((prevData) => [...prevData, newItem]);
    console.log("Checking the insert ", newItem);
    form.resetFields();
  };

  const handleSelectChange = (value) => {
    console.log("Selected MasterId:", value); // Log the selected MasterId
  
    // Find all items in Table11 that match the selected MasterId
    const matchingItems = dataSet.Table11.filter((item) => item.MasterId === value);
  
    // Check if any matching items were found
    if (matchingItems.length === 0) {
      console.warn("No matching items found in Table11 for MasterId:", value);
      return;
    }
  
    // Filter out items that are already in drawerTableData
    const newItemsToAdd = matchingItems.filter((newItem) => 
      !drawerTableData.some((existingItem) => existingItem.ItemCode === newItem.ItemCode)
    );
  
    // Check if there are new items to add
    if (newItemsToAdd.length === 0) {
      console.warn("All matching items are already present in drawerTableData.");
      return;
    }
  
    // Update drawerTableData with the new items
    setDrawerTableData((prevData) => [
      ...prevData,
      ...newItemsToAdd, // Add only non-duplicate items
    ]);
  
    console.log("Added new items to drawerTableData:", newItemsToAdd);
  };

  return (
    <Card title={title}>
      <Row gutter={6}>
        <Col span={12}>
          <InputSelect
            label="Select from Demand"
            name="ItemName"
            options={transformOptions(dataSet?.Table10)}
            onChange={handleSelectChange}
          />
        </Col>
      </Row>
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Row gutter={16}>
          <Col span={6}>
            <InputSelect
              label="Item Name"
              name="ItemName"
              options={itemsOptions}
            />
          </Col>
          <Col span={6}>
            <InputText label="Rate" name="Rate" type="number" />
          </Col>
          <Col span={6}>
            <InputText label="Quantity" name="Quantity" type="number" />
          </Col>
          <Col span={6} style={{ display: "flex", alignItems: "center" }}>
            <Form.Item style={{ width: "100%", marginTop: "22px" }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
              >
                Insert
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default PurchseOrder;
